module.exports = __webpack_public_path__ + "static/media/example_symm4.43d6e8c8.bmp";